import { useEffect, useState } from 'react';

/** Turn JPEG (or any) bytes into an object URL, revoking it on change/unmount. */
export function useObjectUrl(bytes: ArrayBuffer | undefined | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!bytes) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(new Blob([bytes], { type: 'image/jpeg' }));
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [bytes]);
  return url;
}
